import { cn } from "@/lib/cn";
import { useAuthorizedMediaUrl } from "@/utils/authorized-media";

interface AuthorizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  fallback?: React.ReactNode;
}

/**
 * Image that fetches its bytes with the Authorization header before rendering.
 * Use it for storage-protected media (lesson contents); for public images the
 * plain `Image` component is cheaper.
 */
export default function AuthorizedImage({
  src,
  alt,
  className,
  fallback,
  ...props
}: AuthorizedImageProps) {
  const { src: resolvedSrc, isLoading, error } = useAuthorizedMediaUrl(src);

  if (isLoading) {
    return (
      <>
        {fallback ?? (
          <div className={cn("aspect-video w-full animate-pulse rounded-lg bg-default-100", className)} />
        )}
      </>
    );
  }

  if (error || !resolvedSrc) {
    return <p className="text-xs text-default-500">تصویر بارگذاری نشد.</p>;
  }

  return <img src={resolvedSrc} alt={alt} className={className} decoding="async" {...props} />;
}
